import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Gallery from './Gallery';

import iconImg from '../images/Design-icon.png';
import uiImg from '../images/Design-ui.png';
import artImg from '../images/Design-art.png';

import iconImg1 from '../images/Design-icon1.jpg';
import iconImg2 from '../images/Design-icon2.jpg';
import iconImg3 from '../images/Design-icon3.jpg';
import iconImg4 from '../images/Design-icon4.jpg';

import uiImg1 from '../images/Design-ui1.jpg';
import uiImg2 from '../images/Design-ui2.jpg';
import uiImg3 from '../images/Design-ui3.jpg';
import uiImg4 from '../images/Design-ui4.jpg';

import artImg1 from '../images/Design-art1.jpg';
import artImg2 from '../images/Design-art2.jpg';
import artImg3 from '../images/Design-art3.jpg';
import artImg4 from '../images/Design-art4.jpg';

import '../styles/Design.css';

class Design extends React.Component {

  static contextTypes = {
    openModal: PropTypes.func
  };

  render() {
    return (
      <div className={classnames('Design', this.props.className)}>
        <div className="Design-content">
          <h2 className="Design-title">
            {`Design`}
          </h2>
          <div className="Design-projects">
            {
              [
                {
                  image: iconImg,
                  title: 'Icon'
                },
                {
                  image: uiImg,
                  title: 'UI'
                },
                {
                  image: artImg,
                  title: 'Art'
                }
              ].map(({ image, title }, idx) => (
                <div
                  key={idx}
                  className="Design-projectLink"
                  onClick={this._onClickProject.bind(this, idx)}>
                  <div
                    className="Design-projectImg"
                    style={{
                      backgroundImage: `url(${image})`
                    }}
                  />
                  <h3 className="Design-projectTitle">
                    {title}
                  </h3>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    );
  }

  _onClickProject = (idx) => {
    let metricsName, items;

    switch (idx) {
      case 0:
        metricsName = 'Icons';
        items = [
          {
            image: iconImg1,
            title: 'Icons for Amazon WorkDocs'
          },
          {
            image: iconImg2,
            title: 'LifeCheck, Heart Writer, and File Manager'
          },
          {
            image: iconImg3,
            title: (
              <span>
                {`Fusion Icon, `}
                <a
                  className="Design-link"
                  target="_blank"
                  href="http://innerlist.com/"
                  rel="noopener noreferrer">
                  {`InnerList,`}
                </a>
                {` and Activity Icon`}
              </span>
            )
          },
          {
            image: iconImg4,
            title: 'Skeuomorphism vs. Flat Design for File Manager'
          }
        ];
        break;
      case 1:
        metricsName = 'UI';
        items = [
          { image: uiImg1, title: 'Amazon WorkDocs - iPhone' },
          { image: uiImg2, title: 'Amazon WorkDocs - iPad and Android Tablet' },
          { image: uiImg3, title: 'Heart Writer - Innovative keyboard interface' },
          { image: uiImg4, title: 'Simple yet effective desktop UI for specific user goals' }
        ];
        break;
      case 2:
        metricsName = 'Art';
        items = [
          {
            image: artImg1,
            title: 'Drawing - Tools'
          },
          {
            image: artImg2,
            title: (
              <span>
                {`Promotional Video - MobileWorks.com`}
                <a
                  className="Design-link"
                  target="_blank"
                  href="https://www.youtube.com/watch?v=3c4OOw-ZDA4"
                  rel="noopener noreferrer">
                  {`Click here to watch the video.`}
                </a>
              </span>
            )
          },
          {
            image: artImg3,
            title: 'Illustration - the GSMA health conference'
          },
          {
            image: artImg4,
            title: 'Artwork - the unique landing page'
          }
        ];
        break;
      default:
        break;
    }

    this.context.openModal(
      <div className="Design-modal">
        <Gallery
          className="Design-gallery"
          items={items}
          metricsName={`Design.${metricsName}`}
        />
      </div>
    );
  };

}

export default Design;



// WEBPACK FOOTER //
// ./src/components/Design.js